import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const scrollPositions = new Map<string, number>();

export default function ScrollToTop(): null {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType(); // PUSH | POP | REPLACE
  const prevPath = useRef<string>("");
  const prevKey = useRef<string | null>(null);

  const location = useLocation();
  

  useEffect(() => {
    if (navigationType=="REPLACE") return;

    // Disable browser scroll restoration
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const html = document.documentElement;
    const body = document.body;

    // Save previous behavior
    const prevBehavior = html.style.scrollBehavior;

    // Force instant scroll
    html.style.scrollBehavior = "auto";

    if (prevPath.current) {
      scrollPositions.set(prevPath.current, window.scrollY);
    }

    // Allow DOM to render before scrolling
    requestAnimationFrame(() => {
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ block: "start" });
        }
      } else {
        // HARD reset (covers Safari & mobile)
        html.scrollTop = 0;
        body.scrollTop = 0;
        window.scrollTo(0, 0);
      }

      if (navigationType === "POP") {
        // Back / Forward → restore previous scroll
        const y = scrollPositions.get(location.pathname) ?? 0;
        window.scrollTo(0, y);
      }
      // Restore behavior
      html.style.scrollBehavior = prevBehavior;
      prevPath.current = location.pathname;
    });


  }, [pathname, hash, navigationType]);


  return null;
}



